<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="直播ID：">
        <span>{{ query.liveId || '-' }}</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'
export default {
  data() {
    return {
      query: {
        liveId: 0
      }
    }
  },
  created() {
    const routeQuery = this.$route.query
    if (routeQuery.liveId) {
      this.query.liveId = parseInt(routeQuery.liveId)
    }
  },
  methods: {
    handleDownload() {
      return this.$common.confirm('是否确认导出')
        .then(() => liveManageApi.downloadStatisticsAreaByLive(this.query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    }
  }
}
</script>
